import React, { cloneElement, ReactElement, useState } from 'react';
import { useGetOne } from 'react-admin';
import { getChainId } from '../../lib';

export enum ModuleKey {
  QRCODE = 'useQrcode',
  PROMOTER = 'usePromoter',
  LIMITS = 'useLimits',
  ADVERTISEMENT = 'useAdvertisement',
  GIFT = 'useGift',
  BOLAO = 'useBolao',
  ROLETA = 'useRoleta',
  DOTZ = 'useDotz',
  ATTENDANT_TARGET = 'useAttendantTarget',
  SCORING_RULES = 'useScoringRules',
  COMMENT_ANALYSIS = 'useCommentAnalysis',
}

const MODULE_EXPIRY_FIELD: Partial<Record<ModuleKey, string>> = {
  [ModuleKey.ATTENDANT_TARGET]: 'attendantTargetExpiresAt',
};

interface CheckChainUsesModuleProps {
  children: ReactElement;
  module: ModuleKey;
  alwaysOn?: boolean;
  negate?: boolean;
}

const CheckChainUsesModule: React.FC<CheckChainUsesModuleProps> = ({ children, module, negate, ...props }) => {
  const [chainId] = useState(getChainId());
  if (!chainId) { return <></>; }

  const { data: chain } = useGetOne('chains', { id: chainId });

  const moduleEnabled = chain && chain[module] === true;
  const expiryField = MODULE_EXPIRY_FIELD[module];
  const expiryDate = expiryField ? chain?.[expiryField] : null;
  const isExpired = expiryDate ? new Date(expiryDate) < new Date() : false;

  const active = moduleEnabled && !isExpired;
  const shouldRender = negate ? !active : active;

  return shouldRender ? cloneElement(children, props) : null;
}
export default CheckChainUsesModule;
